
import styles from './menu.module.sass'

import classNames from 'classnames'

import BlockWrapper from './layout/block_wrapper'
import ScrollAnimation from './layout/scroll_animation'
import Link from './basic/link'

function Menu(props) {
	const fields = props.fields
	const currentUrl = window.location.href

	return <BlockWrapper {...props} className={styles.menu}>
		<ScrollAnimation styles={styles}>
			<div className={styles.menu_wrapper}>
				<div className={styles.title}>{fields.title}</div>
				{fields.items && fields.items.map((item, i) => {
					return <Link key={i} {...item.link} className={classNames(styles.link, currentUrl == item.link.url ? styles.active : '')}>{item.link.title}</Link>

				})}
			</div>
		</ScrollAnimation>
	</BlockWrapper>
}

export default Menu